module.exports = __webpack_public_path__ + "static/img/coming-soon.67d1d5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coming-soon.png
// module id = i45P
// module chunks = 150